import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck } from '@fortawesome/pro-regular-svg-icons'
import { LabraChatScheduleDetails } from '../../../modules/labraChat/reducer'
import { useStyles } from './ScheduleDetailsCard.styles'

type Props = {
  details: LabraChatScheduleDetails
}

const AVATAR_COLORS = ['avatar0', 'avatar1'] as const

const initialFromRecipient = (value: string) => {
  const local = value.split('@')[0]?.trim() || value.trim()
  const letter = local.charAt(0).toUpperCase()
  return letter || '?'
}

/** Figma 641:3092 / 641:3321 — in-thread Schedule Details summary card. */
export const ScheduleDetailsCard: React.FC<Props> = ({ details }) => {
  const { classes, cx } = useStyles()
  const recipients = details.recipients
  const shown = recipients.slice(0, 2)
  const extra = recipients.length - shown.length

  return (
    <div className={classes.card} data-testid="schedule-details-card">
      <div className={classes.header}>
        <FontAwesomeIcon icon={faCalendarCheck} className={classes.headerIcon} />
        <p className={classes.headerTitle}>Schedule Details</p>
      </div>
      <div className={classes.rows}>
        <div className={classes.row}>
          <span className={classes.label}>Report name</span>
          <span className={classes.value}>{details.reportName}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Recipients</span>
          <span className={classes.value}>
            {recipients.length === 0 ? (
              '—'
            ) : (
              <span
                className={classes.avatarStack}
                data-testid="schedule-details-recipients"
                title={recipients.join(', ')}
              >
                {shown.map((r, i) => (
                  <span
                    key={`${r}-${i}`}
                    className={cx(
                      classes.avatar,
                      classes[AVATAR_COLORS[i % AVATAR_COLORS.length]]
                    )}
                    aria-hidden
                  >
                    {initialFromRecipient(r)}
                  </span>
                ))}
                {extra > 0 ? (
                  <span className={cx(classes.avatar, classes.avatarMore)}>
                    +{extra}
                  </span>
                ) : null}
              </span>
            )}
          </span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Frequency</span>
          <span className={classes.value}>{details.frequency}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Timezone</span>
          <span className={classes.value}>{details.timezone}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Receive via</span>
          <span className={classes.value}>{details.delivery}</span>
        </div>
        <div className={classes.row}>
          <span className={classes.label}>Starts on</span>
          <span className={classes.value}>{details.startsOn || '—'}</span>
        </div>
      </div>
    </div>
  )
}
